module.exports = __webpack_public_path__ + "static/img/Vikas.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Vikas.png
// module id = zcdi
// module chunks = 1